import React from 'react';

import LoadingAnimation from 'components/loading-animation';
import Modal, { ModalContent } from 'components/modal';

export interface IModal3DS {
  onIframeLoaded: (status: boolean) => void;
  onDismiss: (status: boolean) => void;
  url: string;
  loaded?: boolean;
}

const Modal3DS = (props: IModal3DS) => {
  const { onIframeLoaded, url, loaded, onDismiss } = props;

  return (
    <Modal
      onDismiss={onDismiss}
      mParticleEventData={{
        modalAppearanceEventMessage: 'Close 3ds paycomet modal',
      }}
      data-testid="3ds-paycomet-modal"
    >
      <ModalContent expand widthFull>
        {loaded && <LoadingAnimation fillColor={Styles.color.primary} />}
        {!loaded && url && (
          <iframe
            onLoad={() => onIframeLoaded}
            data-testid="3ds-payment-form"
            title="Payment Form"
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
            }}
            src={url}
          ></iframe>
        )}
      </ModalContent>
    </Modal>
  );
};

export default Modal3DS;
